module.exports = __webpack_public_path__ + "img/05_map.739d7053.webp";